import { render, staticRenderFns } from "./PositionSettingsEditForm.vue?vue&type=template&id=0fa778d6&scoped=true&"
import script from "./PositionSettingsEditForm.vue?vue&type=script&lang=js&"
export * from "./PositionSettingsEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa778d6",
  null
  
)

export default component.exports